var _path, _path2, _g, _g2, _rect, _rect2, _g3, _rect3, _path3, _g4, _g5, _g6, _g7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiChannelNode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 100,
    viewBox: "0 0 199 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2652 63.2652C27.1187 63.4116 26.8813 63.4116 26.7348 63.2652L24.3484 60.8787C24.2019 60.7322 24.2019 60.4948 24.3484 60.3483C24.4948 60.2019 24.7322 60.2019 24.8787 60.3483L27 62.4697L29.1213 60.3483C29.2678 60.2019 29.5052 60.2019 29.6516 60.3483C29.7981 60.4948 29.7981 60.7322 29.6516 60.8787L27.2652 63.2652ZM99.375 30V31.7662H98.625V30H99.375ZM99.375 32.9436V34.7098H98.625V32.9436H99.375ZM99.375 34.7098C99.375 35.2268 99.3372 35.7351 99.264 36.2322L98.522 36.1231C98.5898 35.662 98.625 35.1901 98.625 34.7098H99.375ZM99.0664 37.2313C98.8157 38.235 98.419 39.1807 97.9001 40.0445L97.2572 39.6584C97.7385 38.8571 98.1063 37.9801 98.3387 37.0496L99.0664 37.2313ZM97.3337 40.8906C96.7255 41.7094 95.9996 42.4353 95.1809 43.0435L94.7336 42.4414C95.4934 41.877 96.1672 41.2032 96.7316 40.4434L97.3337 40.8906ZM94.3348 43.6099C93.471 44.1287 92.5252 44.5255 91.5215 44.7761L91.3398 44.0485C92.2703 43.8161 93.1473 43.4483 93.9486 42.967L94.3348 43.6099ZM90.5224 44.9738C90.0253 45.0469 89.517 45.0848 89 45.0848V44.3348C89.4803 44.3348 89.9522 44.2996 90.4133 44.2318L90.5224 44.9738ZM89 45.0848H87.5V44.3348H89V45.0848ZM86.5 45.0848H83.5V44.3348H86.5V45.0848ZM82.5 45.0848H79.5V44.3348H82.5V45.0848ZM78.5 45.0848H75.5V44.3348H78.5V45.0848ZM74.5 45.0848H71.5V44.3348H74.5V45.0848ZM70.5 45.0848H67.5V44.3348H70.5V45.0848ZM66.5 45.0848H63.5V44.3348H66.5V45.0848ZM62.5 45.0848H59.5V44.3348H62.5V45.0848ZM58.5 45.0848H55.5V44.3348H58.5V45.0848ZM54.5 45.0848H51.5V44.3348H54.5V45.0848ZM50.5 45.0848H47.5V44.3348H50.5V45.0848ZM46.5 45.0848H43.5V44.3348H46.5V45.0848ZM42.5 45.0848H39.5V44.3348H42.5V45.0848ZM38.5 45.0848H37V44.3348H38.5V45.0848ZM37 45.0848C36.5197 45.0848 36.0478 45.1199 35.5867 45.1877L35.4776 44.4457C35.9747 44.3726 36.483 44.3348 37 44.3348V45.0848ZM34.6602 45.3711C33.7297 45.6034 32.8527 45.9713 32.0514 46.4526L31.6652 45.8097C32.529 45.2908 33.4748 44.8941 34.4785 44.6434L34.6602 45.3711ZM31.2664 46.9781C30.5066 47.5426 29.8328 48.2163 29.2684 48.9761L28.6663 48.5289C29.2745 47.7102 30.0004 46.9843 30.8191 46.3761L31.2664 46.9781ZM28.7428 49.7612C28.2615 50.5625 27.8937 51.4394 27.6613 52.37L26.9336 52.1883C27.1843 51.1845 27.581 50.2388 28.0999 49.375L28.7428 49.7612ZM27.478 53.2965C27.4102 53.7576 27.375 54.2294 27.375 54.7098H26.625C26.625 54.1928 26.6628 53.6844 26.736 53.1873L27.478 53.2965ZM27.375 54.7098V56.2642H26.625V54.7098H27.375ZM27.375 57.3005V60.4093H26.625V57.3005H27.375ZM27.375 61.4456V63H26.625V61.4456H27.375Z",
    fill: "#42CFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.735 63.2652C170.881 63.4116 171.119 63.4116 171.265 63.2652L173.652 60.8787C173.798 60.7322 173.798 60.4948 173.652 60.3483C173.505 60.2019 173.268 60.2019 173.121 60.3483L171 62.4697L168.879 60.3483C168.732 60.2019 168.495 60.2019 168.348 60.3483C168.202 60.4948 168.202 60.7322 168.348 60.8787L170.735 63.2652ZM98.625 30V31.7662H99.375V30H98.625ZM98.625 32.9436V34.7098H99.375V32.9436H98.625ZM98.625 34.7098C98.625 35.2268 98.6628 35.7351 98.736 36.2322L99.478 36.1231C99.4102 35.662 99.375 35.1901 99.375 34.7098H98.625ZM98.9336 37.2313C99.1843 38.235 99.581 39.1807 100.1 40.0445L100.743 39.6584C100.262 38.8571 99.8937 37.9801 99.6613 37.0496L98.9336 37.2313ZM100.666 40.8906C101.274 41.7094 102 42.4353 102.819 43.0435L103.266 42.4414C102.507 41.877 101.833 41.2032 101.268 40.4434L100.666 40.8906ZM103.665 43.6099C104.529 44.1287 105.475 44.5255 106.478 44.7761L106.66 44.0485C105.73 43.8161 104.853 43.4483 104.051 42.967L103.665 43.6099ZM107.478 44.9738C107.975 45.0469 108.483 45.0848 109 45.0848V44.3348C108.52 44.3348 108.048 44.2996 107.587 44.2318L107.478 44.9738ZM109 45.0848H110.5V44.3348H109V45.0848ZM111.5 45.0848H114.5V44.3348H111.5V45.0848ZM115.5 45.0848H118.5V44.3348H115.5V45.0848ZM119.5 45.0848H122.5V44.3348H119.5V45.0848ZM123.5 45.0848H126.5V44.3348H123.5V45.0848ZM127.5 45.0848H130.5V44.3348H127.5V45.0848ZM131.5 45.0848H134.5V44.3348H131.5V45.0848ZM135.5 45.0848H138.5V44.3348H135.5V45.0848ZM139.5 45.0848H142.5V44.3348H139.5V45.0848ZM143.5 45.0848H146.5V44.3348H143.5V45.0848ZM147.5 45.0848H150.5V44.3348H147.5V45.0848ZM151.5 45.0848H154.5V44.3348H151.5V45.0848ZM155.5 45.0848H158.5V44.3348H155.5V45.0848ZM159.5 45.0848H161V44.3348H159.5V45.0848ZM161 45.0848C161.48 45.0848 161.952 45.1199 162.413 45.1877L162.522 44.4457C162.025 44.3726 161.517 44.3348 161 44.3348V45.0848ZM163.34 45.3711C164.27 45.6034 165.147 45.9713 165.949 46.4526L166.335 45.8097C165.471 45.2908 164.525 44.8941 163.522 44.6434L163.34 45.3711ZM166.734 46.9781C167.493 47.5426 168.167 48.2163 168.732 48.9761L169.334 48.5289C168.726 47.7102 168 46.9843 167.181 46.3761L166.734 46.9781ZM169.257 49.7612C169.738 50.5625 170.106 51.4394 170.339 52.37L171.066 52.1883C170.816 51.1845 170.419 50.2388 169.9 49.375L169.257 49.7612ZM170.522 53.2965C170.59 53.7576 170.625 54.2294 170.625 54.7098H171.375C171.375 54.1928 171.337 53.6844 171.264 53.1873L170.522 53.2965ZM170.625 54.7098V56.2642H171.375V54.7098H170.625ZM170.625 57.3005V60.4093H171.375V57.3005H170.625ZM170.625 61.4456V63H171.375V61.4456H170.625Z",
    fill: "#42CFEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_934_12001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99 30V40.7098C99 42.9189 100.791 44.7098 103 44.7098H167C169.209 44.7098 171 46.5006 171 48.7098V63",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_934_12001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99 30V40.7098C99 42.9189 97.2091 44.7098 95 44.7098H31C28.7909 44.7098 27 46.5006 27 48.7098V63",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddd_934_12001)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 6,
    width: 100,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FC8F37"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_12001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.3327 19.9974V19.9307C58.3327 19.3707 58.3327 19.0907 58.4417 18.8767C58.5375 18.6886 58.6905 18.5356 58.8787 18.4397C59.0926 18.3307 59.3726 18.3307 59.9327 18.3307H62.066C62.6261 18.3307 62.9061 18.3307 63.12 18.4397C63.3082 18.5356 63.4611 18.6886 63.557 18.8767C63.666 19.0907 63.666 19.3707 63.666 19.9307V19.9974M58.3327 19.9974C57.9645 19.9974 57.666 20.2959 57.666 20.6641C57.666 21.0323 57.9645 21.3307 58.3327 21.3307C58.7009 21.3307 58.9993 21.0323 58.9993 20.6641C58.9993 20.2959 58.7009 19.9974 58.3327 19.9974ZM63.666 19.9974C63.2978 19.9974 62.9993 20.2959 62.9993 20.6641C62.9993 21.0323 63.2978 21.3307 63.666 21.3307C64.0342 21.3307 64.3327 21.0323 64.3327 20.6641C64.3327 20.2959 64.0342 19.9974 63.666 19.9974ZM60.9993 19.9974C60.6312 19.9974 60.3327 20.2959 60.3327 20.6641C60.3327 21.0323 60.6312 21.3307 60.9993 21.3307C61.3675 21.3307 61.666 21.0323 61.666 20.6641C61.666 20.2959 61.3675 19.9974 60.9993 19.9974ZM60.9993 19.9974V16.6641M58.9993 16.6641H62.9993C63.31 16.6641 63.4653 16.6641 63.5878 16.6133C63.7512 16.5457 63.8809 16.4159 63.9486 16.2525C63.9993 16.13 63.9993 15.9747 63.9993 15.6641C63.9993 15.3534 63.9993 15.1981 63.9486 15.0756C63.8809 14.9123 63.7512 14.7825 63.5878 14.7148C63.4653 14.6641 63.31 14.6641 62.9993 14.6641H58.9993C58.6887 14.6641 58.5334 14.6641 58.4109 14.7148C58.2475 14.7825 58.1178 14.9123 58.0501 15.0756C57.9993 15.1981 57.9993 15.3534 57.9993 15.6641C57.9993 15.9747 57.9993 16.13 58.0501 16.2525C58.1178 16.4159 58.2475 16.5457 58.4109 16.6133C58.5334 16.6641 58.6887 16.6641 58.9993 16.6641Z",
    stroke: "#FFF4F0",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 16,
    width: 70,
    height: 4,
    rx: 1,
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7343 64.2652C98.8808 64.4116 99.1182 64.4116 99.2647 64.2652L101.651 61.8787C101.798 61.7322 101.798 61.4948 101.651 61.3484C101.505 61.2019 101.267 61.2019 101.121 61.3484L98.9995 63.4697L96.8782 61.3484C96.7317 61.2019 96.4943 61.2019 96.3479 61.3484C96.2014 61.4948 96.2014 61.7322 96.3479 61.8787L98.7343 64.2652ZM98.6245 37L98.6245 38.4464L99.3745 38.4464L99.3745 37L98.6245 37ZM98.6245 39.4107L98.6245 42.3036L99.3745 42.3036L99.3745 39.4107L98.6245 39.4107ZM98.6245 43.2679L98.6245 46.1607L99.3745 46.1607L99.3745 43.2679L98.6245 43.2679ZM98.6245 47.125L98.6245 50.0179L99.3745 50.0179L99.3745 47.125L98.6245 47.125ZM98.6245 50.9821L98.6245 53.875L99.3745 53.875L99.3745 50.9821L98.6245 50.9821ZM98.6245 54.8393L98.6245 57.7321L99.3745 57.7321L99.3745 54.8393L98.6245 54.8393ZM98.6245 58.6964L98.6245 61.5893L99.3745 61.5893L99.3745 58.6964L98.6245 58.6964ZM98.6245 62.5536L98.6245 64L99.3745 64L99.3745 62.5536L98.6245 62.5536Z",
    fill: "#42CFEF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_934_12001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.9995 38L98.9995 63",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ddd_934_12001)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 64,
    width: 50,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FC8F37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.666 75.6641C19.7605 75.6641 19.8397 75.6321 19.9037 75.5681C19.9677 75.5041 19.9996 75.425 19.9993 75.3307C19.9993 75.2363 19.9673 75.1572 19.9033 75.0934C19.8393 75.0296 19.7602 74.9976 19.666 74.9974C19.5716 74.9974 19.4925 75.0294 19.4287 75.0934C19.3649 75.1574 19.3329 75.2365 19.3327 75.3307C19.3327 75.4252 19.3647 75.5044 19.4287 75.5684C19.4927 75.6324 19.5718 75.6643 19.666 75.6641ZM20.9993 75.6641C21.0938 75.6641 21.173 75.6321 21.237 75.5681C21.301 75.5041 21.3329 75.425 21.3327 75.3307C21.3327 75.2363 21.3007 75.1572 21.2367 75.0934C21.1727 75.0296 21.0936 74.9976 20.9993 74.9974C20.9049 74.9974 20.8258 75.0294 20.762 75.0934C20.6982 75.1574 20.6662 75.2365 20.666 75.3307C20.666 75.4252 20.698 75.5044 20.762 75.5684C20.826 75.6324 20.9051 75.6643 20.9993 75.6641ZM22.3327 75.6641C22.4271 75.6641 22.5063 75.6321 22.5703 75.5681C22.6343 75.5041 22.6662 75.425 22.666 75.3307C22.666 75.2363 22.634 75.1572 22.57 75.0934C22.506 75.0296 22.4269 74.9976 22.3327 74.9974C22.2382 74.9974 22.1591 75.0294 22.0953 75.0934C22.0316 75.1574 21.9996 75.2365 21.9993 75.3307C21.9993 75.4252 22.0313 75.5044 22.0953 75.5684C22.1593 75.6324 22.2385 75.6643 22.3327 75.6641ZM18.9993 77.9974L18.2327 78.7641C18.1271 78.8696 18.0062 78.8933 17.87 78.8351C17.7338 78.7768 17.6658 78.6726 17.666 78.5224V73.3307C17.666 73.1474 17.7313 72.9905 17.862 72.8601C17.9927 72.7296 18.1496 72.6643 18.3327 72.6641H23.666C23.8493 72.6641 24.0064 72.7294 24.137 72.8601C24.2677 72.9907 24.3329 73.1476 24.3327 73.3307V77.3307C24.3327 77.5141 24.2675 77.6711 24.137 77.8017C24.0066 77.9324 23.8496 77.9976 23.666 77.9974H18.9993ZM18.716 77.3307H23.666V73.3307H18.3327V77.7057L18.716 77.3307Z",
    fill: "#FFF4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2891 74.674C37.255 74.3714 37.1143 74.1371 36.8672 73.9709C36.62 73.8026 36.3089 73.7184 35.9339 73.7184C35.6655 73.7184 35.4332 73.761 35.2372 73.8462C35.0412 73.9293 34.8888 74.0444 34.7802 74.1914C34.6737 74.3363 34.6204 74.5014 34.6204 74.6868C34.6204 74.8423 34.6566 74.9766 34.729 75.0895C34.8036 75.2024 34.9006 75.2972 35.0199 75.3739C35.1413 75.4485 35.2713 75.5114 35.4098 75.5625C35.5483 75.6115 35.6815 75.652 35.8093 75.6839L36.4485 75.8501C36.6573 75.9013 36.8714 75.9705 37.0909 76.0579C37.3104 76.1452 37.5138 76.2603 37.7013 76.4031C37.8888 76.5458 38.0401 76.7227 38.1552 76.9336C38.2724 77.1445 38.331 77.397 38.331 77.6911C38.331 78.0618 38.2351 78.391 38.0433 78.6786C37.8537 78.9663 37.5778 79.1932 37.2156 79.3594C36.8555 79.5256 36.4197 79.6087 35.9084 79.6087C35.4183 79.6087 34.9943 79.5309 34.6364 79.3754C34.2784 79.2198 33.9982 78.9993 33.7958 78.7138C33.5934 78.4261 33.4815 78.0852 33.4602 77.6911H34.451C34.4702 77.9276 34.5469 78.1246 34.6811 78.2823C34.8175 78.4379 34.9911 78.554 35.2021 78.6307C35.4151 78.7053 35.6484 78.7425 35.902 78.7425C36.1811 78.7425 36.4293 78.6989 36.6467 78.6115C36.8661 78.522 37.0387 78.3984 37.1644 78.2408C37.2901 78.081 37.353 77.8945 37.353 77.6815C37.353 77.4876 37.2976 77.3288 37.1868 77.2053C37.0781 77.0817 36.93 76.9794 36.7425 76.8984C36.5572 76.8175 36.3473 76.7461 36.1129 76.6843L35.3395 76.4734C34.8153 76.3306 34.3999 76.1207 34.093 75.8438C33.7884 75.5668 33.636 75.2003 33.636 74.7443C33.636 74.3672 33.7383 74.038 33.9428 73.7567C34.1474 73.4755 34.4244 73.2571 34.7738 73.1016C35.1232 72.9439 35.5174 72.8651 35.9563 72.8651C36.3995 72.8651 36.7905 72.9428 37.1293 73.0984C37.4702 73.2539 37.7386 73.468 37.9347 73.7408C38.1307 74.0114 38.233 74.3224 38.2415 74.674H37.2891ZM39.5111 72.9545H40.7096L42.7934 78.0426H42.8701L44.9539 72.9545H46.1524V79.5H45.2128V74.7635H45.1521L43.2217 79.4904H42.4419L40.5115 74.7603H40.4507V79.5H39.5111V72.9545ZM51.1582 74.674C51.1241 74.3714 50.9835 74.1371 50.7363 73.9709C50.4892 73.8026 50.1781 73.7184 49.8031 73.7184C49.5346 73.7184 49.3024 73.761 49.1064 73.8462C48.9103 73.9293 48.758 74.0444 48.6493 74.1914C48.5428 74.3363 48.4895 74.5014 48.4895 74.6868C48.4895 74.8423 48.5257 74.9766 48.5982 75.0895C48.6728 75.2024 48.7697 75.2972 48.889 75.3739C49.0105 75.4485 49.1404 75.5114 49.2789 75.5625C49.4174 75.6115 49.5506 75.652 49.6784 75.6839L50.3176 75.8501C50.5265 75.9013 50.7406 75.9705 50.96 76.0579C51.1795 76.1452 51.383 76.2603 51.5705 76.4031C51.758 76.5458 51.9093 76.7227 52.0243 76.9336C52.1415 77.1445 52.2001 77.397 52.2001 77.6911C52.2001 78.0618 52.1042 78.391 51.9125 78.6786C51.7228 78.9663 51.4469 79.1932 51.0847 79.3594C50.7246 79.5256 50.2889 79.6087 49.7775 79.6087C49.2875 79.6087 48.8635 79.5309 48.5055 79.3754C48.1475 79.2198 47.8674 78.9993 47.665 78.7138C47.4625 78.4261 47.3507 78.0852 47.3294 77.6911H48.3201C48.3393 77.9276 48.416 78.1246 48.5502 78.2823C48.6866 78.4379 48.8603 78.554 49.0712 78.6307C49.2843 78.7053 49.5176 78.7425 49.7711 78.7425C50.0502 78.7425 50.2985 78.6989 50.5158 78.6115C50.7353 78.522 50.9078 78.3984 51.0336 78.2408C51.1593 78.081 51.2221 77.8945 51.2221 77.6815C51.2221 77.4876 51.1667 77.3288 51.0559 77.2053C50.9473 77.0817 50.7992 76.9794 50.6117 76.8984C50.4263 76.8175 50.2164 76.7461 49.9821 76.6843L49.2086 76.4734C48.6845 76.3306 48.269 76.1207 47.9622 75.8438C47.6575 75.5668 47.5051 75.2003 47.5051 74.7443C47.5051 74.3672 47.6074 74.038 47.812 73.7567C48.0165 73.4755 48.2935 73.2571 48.6429 73.1016C48.9924 72.9439 49.3865 72.8651 49.8255 72.8651C50.2686 72.8651 50.6596 72.9428 50.9984 73.0984C51.3393 73.2539 51.6078 73.468 51.8038 73.7408C51.9998 74.0114 52.1021 74.3224 52.1106 74.674H51.1582Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ddd_934_12001)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 64,
    width: 53,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FC8F37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3327 74.0026C86.3327 73.6359 86.0327 73.3359 85.666 73.3359H80.3327C79.966 73.3359 79.666 73.6359 79.666 74.0026V78.0026C79.666 78.3693 79.966 78.6693 80.3327 78.6693H85.666C86.0327 78.6693 86.3327 78.3693 86.3327 78.0026V74.0026ZM85.666 74.0026L82.9993 75.6693L80.3327 74.0026H85.666ZM85.666 78.0026H80.3327V74.6693L82.9993 76.3359L85.666 74.6693V78.0026Z",
    fill: "#FFF4F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7191 79.5V72.9545H99.8228V73.8047H96.7067V75.799H99.6087V76.646H96.7067V78.6499H99.8612V79.5H95.7191ZM101.065 79.5V74.5909H101.983V75.3899H102.043C102.146 75.1193 102.313 74.9084 102.545 74.7571C102.777 74.6037 103.055 74.527 103.379 74.527C103.707 74.527 103.982 74.6037 104.204 74.7571C104.427 74.9105 104.593 75.1214 104.699 75.3899H104.75C104.867 75.1278 105.054 74.919 105.31 74.7635C105.565 74.6058 105.87 74.527 106.224 74.527C106.669 74.527 107.032 74.6665 107.313 74.9457C107.597 75.2248 107.739 75.6456 107.739 76.2081V79.5H106.783V76.2976C106.783 75.9652 106.692 75.7244 106.511 75.5753C106.33 75.4261 106.114 75.3516 105.862 75.3516C105.551 75.3516 105.31 75.4474 105.137 75.6392C104.964 75.8288 104.878 76.0728 104.878 76.3711V79.5H103.926V76.2369C103.926 75.9705 103.843 75.7564 103.676 75.5945C103.51 75.4325 103.294 75.3516 103.028 75.3516C102.847 75.3516 102.679 75.3995 102.526 75.4954C102.375 75.5891 102.252 75.7202 102.158 75.8885C102.067 76.0568 102.021 76.2518 102.021 76.4734V79.5H101.065ZM110.448 79.6087C110.137 79.6087 109.856 79.5511 109.604 79.4361C109.353 79.3189 109.154 79.1495 109.007 78.9279C108.862 78.7063 108.789 78.4347 108.789 78.1129C108.789 77.8359 108.843 77.608 108.949 77.429C109.056 77.25 109.199 77.1083 109.381 77.0039C109.562 76.8995 109.764 76.8207 109.988 76.7674C110.211 76.7141 110.439 76.6737 110.672 76.646C110.966 76.6119 111.204 76.5842 111.388 76.5629C111.571 76.5394 111.704 76.5021 111.787 76.451C111.87 76.3999 111.912 76.3168 111.912 76.2017V76.1793C111.912 75.9002 111.833 75.6839 111.675 75.5305C111.52 75.3771 111.287 75.3004 110.979 75.3004C110.657 75.3004 110.403 75.3718 110.218 75.5146C110.035 75.6552 109.908 75.8118 109.838 75.9844L108.939 75.7798C109.046 75.4815 109.202 75.2408 109.406 75.0575C109.613 74.8722 109.85 74.7379 110.119 74.6548C110.387 74.5696 110.67 74.527 110.966 74.527C111.162 74.527 111.369 74.5504 111.589 74.5973C111.811 74.642 112.017 74.7251 112.209 74.8466C112.403 74.968 112.562 75.1417 112.685 75.3675C112.809 75.5913 112.871 75.8821 112.871 76.2401V79.5H111.937V78.8288H111.899C111.837 78.9524 111.744 79.0739 111.621 79.1932C111.497 79.3125 111.339 79.4116 111.145 79.4904C110.951 79.5692 110.719 79.6087 110.448 79.6087ZM110.656 78.8416C110.92 78.8416 111.146 78.7894 111.333 78.685C111.523 78.5806 111.667 78.4442 111.765 78.2759C111.865 78.1055 111.915 77.9233 111.915 77.7294V77.0966C111.881 77.1307 111.815 77.1626 111.717 77.1925C111.621 77.2202 111.511 77.2447 111.388 77.266C111.264 77.2852 111.144 77.3033 111.026 77.3203C110.909 77.3352 110.811 77.348 110.732 77.3587C110.547 77.3821 110.378 77.4215 110.224 77.4769C110.073 77.5323 109.952 77.6122 109.86 77.7166C109.77 77.8189 109.726 77.9553 109.726 78.1257C109.726 78.3622 109.813 78.5412 109.988 78.6626C110.162 78.782 110.385 78.8416 110.656 78.8416ZM114.143 79.5V74.5909H115.099V79.5H114.143ZM114.626 73.8335C114.46 73.8335 114.317 73.7781 114.198 73.6673C114.081 73.5543 114.022 73.4201 114.022 73.2646C114.022 73.1069 114.081 72.9727 114.198 72.8619C114.317 72.7489 114.46 72.6925 114.626 72.6925C114.792 72.6925 114.934 72.7489 115.051 72.8619C115.17 72.9727 115.23 73.1069 115.23 73.2646C115.23 73.4201 115.17 73.5543 115.051 73.6673C114.934 73.7781 114.792 73.8335 114.626 73.8335ZM117.34 72.9545V79.5H116.385V72.9545H117.34Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ddd_934_12001)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 64,
    width: 54,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 70,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#FC8F37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.001 77.6667V78C147.001 78.2652 147.106 78.5196 147.294 78.7071C147.481 78.8946 147.735 79 148.001 79C148.266 79 148.52 78.8946 148.708 78.7071C148.895 78.5196 149.001 78.2652 149.001 78V77.6667M147.334 73.6667C147.334 73.4899 147.404 73.3203 147.529 73.1953C147.654 73.0702 147.824 73 148.001 73C148.177 73 148.347 73.0702 148.472 73.1953C148.597 73.3203 148.667 73.4899 148.667 73.6667C149.05 73.8477 149.376 74.1294 149.611 74.4818C149.846 74.8341 149.981 75.2437 150.001 75.6667V76.6667C150.026 76.8739 150.099 77.0724 150.215 77.246C150.331 77.4197 150.486 77.5638 150.667 77.6667H145.334C145.516 77.5638 145.671 77.4197 145.786 77.246C145.902 77.0724 145.976 76.8739 146.001 76.6667V75.6667C146.021 75.2437 146.155 74.8341 146.39 74.4818C146.625 74.1294 146.951 73.8477 147.334 73.6667Z",
    stroke: "#FFF4F0",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.707 72.9545V79.5H160.719V72.9545H161.707ZM164.024 76.5852V79.5H163.068V74.5909H163.985V75.3899H164.046C164.159 75.13 164.336 74.9212 164.577 74.7635C164.82 74.6058 165.125 74.527 165.494 74.527C165.828 74.527 166.121 74.5973 166.373 74.7379C166.624 74.8764 166.819 75.0831 166.958 75.358C167.096 75.6328 167.165 75.9727 167.165 76.3775V79.5H166.21V76.4925C166.21 76.1367 166.117 75.8587 165.932 75.6584C165.746 75.456 165.492 75.3548 165.168 75.3548C164.946 75.3548 164.749 75.4027 164.577 75.4986C164.406 75.5945 164.271 75.7351 164.171 75.9205C164.073 76.1037 164.024 76.3253 164.024 76.5852ZM168.524 79.5V72.9545H169.479V75.3867H169.537C169.592 75.2844 169.672 75.1662 169.777 75.032C169.881 74.8977 170.026 74.7805 170.211 74.6804C170.397 74.5781 170.642 74.527 170.946 74.527C171.343 74.527 171.696 74.6271 172.007 74.8274C172.319 75.0277 172.563 75.3164 172.739 75.6935C172.918 76.0707 173.008 76.5245 173.008 77.055C173.008 77.5856 172.919 78.0405 172.743 78.4197C172.566 78.7969 172.323 79.0877 172.014 79.2923C171.705 79.4947 171.352 79.5959 170.956 79.5959C170.658 79.5959 170.414 79.5458 170.224 79.4457C170.037 79.3455 169.89 79.2283 169.783 79.0941C169.676 78.9599 169.594 78.8406 169.537 78.7362H169.457V79.5H168.524ZM169.46 77.0455C169.46 77.3906 169.51 77.6932 169.61 77.9531C169.711 78.2131 169.855 78.4165 170.045 78.5636C170.235 78.7085 170.467 78.7809 170.742 78.7809C171.027 78.7809 171.266 78.7053 171.458 78.554C171.65 78.4006 171.794 78.1928 171.892 77.9308C171.993 77.6687 172.043 77.3736 172.043 77.0455C172.043 76.7216 171.994 76.4308 171.896 76.1729C171.8 75.9151 171.655 75.7116 171.461 75.5625C171.269 75.4134 171.029 75.3388 170.742 75.3388C170.465 75.3388 170.23 75.4102 170.039 75.5529C169.849 75.6957 169.705 75.8949 169.607 76.1506C169.509 76.4062 169.46 76.7045 169.46 77.0455ZM176.149 79.5991C175.688 79.5991 175.287 79.4936 174.944 79.2827C174.601 79.0717 174.334 78.7766 174.145 78.3974C173.955 78.0181 173.86 77.5749 173.86 77.0678C173.86 76.5586 173.955 76.1133 174.145 75.7319C174.334 75.3505 174.601 75.0543 174.944 74.8434C175.287 74.6325 175.688 74.527 176.149 74.527C176.609 74.527 177.011 74.6325 177.354 74.8434C177.697 75.0543 177.963 75.3505 178.153 75.7319C178.342 76.1133 178.437 76.5586 178.437 77.0678C178.437 77.5749 178.342 78.0181 178.153 78.3974C177.963 78.7766 177.697 79.0717 177.354 79.2827C177.011 79.4936 176.609 79.5991 176.149 79.5991ZM176.152 78.7969C176.45 78.7969 176.697 78.718 176.893 78.5604C177.089 78.4027 177.234 78.1928 177.328 77.9308C177.424 77.6687 177.472 77.38 177.472 77.0646C177.472 76.7514 177.424 76.4638 177.328 76.2017C177.234 75.9375 177.089 75.7255 176.893 75.5657C176.697 75.4059 176.45 75.326 176.152 75.326C175.851 75.326 175.602 75.4059 175.404 75.5657C175.208 75.7255 175.062 75.9375 174.966 76.2017C174.872 76.4638 174.826 76.7514 174.826 77.0646C174.826 77.38 174.872 77.6687 174.966 77.9308C175.062 78.1928 175.208 78.4027 175.404 78.5604C175.602 78.718 175.851 78.7969 176.152 78.7969ZM180.065 74.5909L181.148 76.5021L182.241 74.5909H183.286L181.755 77.0455L183.299 79.5H182.254L181.148 77.6655L180.045 79.5H178.997L180.525 77.0455L179.016 74.5909H180.065Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_934_12001",
    x: 90.625,
    y: 22,
    width: 88.75,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_934_12001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_934_12001",
    x: 18.625,
    y: 22,
    width: 88.75,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_934_12001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddd_934_12001",
    x: 40,
    y: 0,
    width: 118,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_934_12001",
    result: "effect2_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_934_12001",
    result: "effect3_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_934_12001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_934_12001",
    x: 85.6245,
    y: 25,
    width: 26.75,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_934_12001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ddd_934_12001",
    x: 0,
    y: 58,
    width: 68,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_934_12001",
    result: "effect2_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_934_12001",
    result: "effect3_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_934_12001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ddd_934_12001",
    x: 62,
    y: 58,
    width: 71,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_934_12001",
    result: "effect2_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_934_12001",
    result: "effect3_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_934_12001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ddd_934_12001",
    x: 127,
    y: 58,
    width: 72,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_934_12001",
    result: "effect2_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_934_12001",
    result: "effect3_dropShadow_934_12001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_934_12001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_12001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(57 14)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiChannelNode);
export default __webpack_public_path__ + "static/media/multiChannelNode.c65a57454c172630a63f815e11fdaa88.svg";
export { ForwardRef as ReactComponent };